import { WidgetInputMenuButton } from '../../../rapid-ui/inputs/widgets/widget-input-menu-button'
import type { LayerType } from '../data/v1'
import { useLayerTreeActions } from '../use-layer-tree-actions'

const LAYER_MENU_ITEMS: Array<{ type: LayerType; label: string }> = [
	{ type: 'content', label: 'Content' },
	{ type: 'backdrop', label: 'Backdrop' },
	{ type: 'substack', label: 'Substack' },
	{ type: 'text', label: 'Text' },
	{ type: 'shape', label: 'Shape' },
	{ type: 'image', label: 'Image' },
]

export function LayerAdder() {
	const { addLayer } = useLayerTreeActions()

	// Placement is `addLayer`'s call — `resolveAddPlacement` reads the selection itself.
	const menuItems = LAYER_MENU_ITEMS.map(({ type, label }) => ({
		id: type,
		label,
		onSelect: () => addLayer(type),
	}))

	return <WidgetInputMenuButton label="+ Add" items={menuItems} />
}
